export const GENERIC_ERROR =
  "Oops! Looks like there was an error processing your request. Please try again.";

export const HEADERS = {
  HATCH_CLIENT_HEADER: "X-Hatch-Client",
  HATCH_AUTH_HEADER: "X-HatchBaby-Auth",
  HATCH_SUPPLEMENTAL_HEADER: "X-HatchBaby-Supplemental",
  CLIENT_NAME: "answeb",
};

const constants = {
  HEADERS,
  GENERIC_ERROR,
};

export default constants;
